import { Component, inject } from '@angular/core';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { userService } from '../../../services/user-service';
import { PrimeNGModules } from '../../../shared/alpha-shared.module';
@Component({
    selector: 'app-user',
    standalone: true,
    imports: [PrimeNGModules, TranslatePipe],
    templateUrl: './user.component.html',
})
export class UserComponent {
    userService = inject(userService);

    currentIcon: string = 'pi pi-chevron-down';
    userInfo: any = {
        displayName: '',
        username: '',
        logo: '',
    };
    loading: boolean = false;

    ngOnInit() {
        this.userService.getUser().subscribe((res: any) => {
            if (!(res && res.response && typeof res.response === 'object')) {
                console.error('Error: Unable to fetch user information');
                return;
            }
            this.userInfo = {
                username: res.response.username,
                displayName: res.response.displayName,
                logo: res.response.displayName
                    .split(' ')
                    .map((word: string) => word.charAt(0))
                    .join('')
                    .toUpperCase()
                    .substring(0, 2),
                ...res.response,
            };
        });
    }

    toggle(op: any, event: any) {
        this.currentIcon = this.currentIcon === 'pi pi-chevron-down' ? 'pi pi-chevron-up' : 'pi pi-chevron-down';
        op.toggle(event);
        event.stopPropagation();
    }

    userLogOut() {
        this.loading = true;
        setTimeout(() => {
            this.userService.logOut();
            this.loading = false;
        }, 1000);
    }
}
